/**
 * Core Entity Types
 *
 * Single source of truth for entity type identifiers used across the system.
 * Other type consts (ErrorDomains, AuditEntityTypes) extend from this base.
 */
export const EntityTypes = {
    // Core entities
    USER: 'user',
    ADMIN: 'admin',
    TENANT: 'tenant',
    // Token entities
    TOKEN: 'token',
    TOKEN_METADATA: 'token_metadata',
    TOKEN_TYPE: 'token_type',
    // Financial entities
    WALLET: 'wallet',
    BALANCE: 'balance',
    TRANSACTION: 'transaction',
    PURCHASE: 'purchase',
    // Business entities
    BUSINESS: 'business',
    BUSINESS_TYPE: 'business_type',
    // Campaign entities
    CAMPAIGN: 'campaign',
    CAMPAIGN_TRIGGER: 'campaign_trigger',
    // Redemption entities
    REDEMPTION: 'redemption',
    REDEMPTION_TYPE: 'redemption_type',
    // Booking entities
    BOOKING: 'booking',
    // Infrastructure entities
    CONTRACT: 'contract',
    SIGNING_ACCOUNT: 'signing_account',
    API_KEY: 'api_key',
    WEBHOOK: 'webhook',
    // Service domains
    ANALYTICS: 'analytics',
    CHAIN: 'chain',
    FILE: 'file',
    JWKS: 'jwks',
    PROJECT: 'project',
};
/**
 * Error-specific domains (extends EntityTypes)
 *
 * Includes entity types plus error-specific classification domains.
 */
export const ErrorDomains = {
    ...EntityTypes,
    // Error-specific domains (not entities, but error classifications)
    VALIDATION: 'validation',
    SYSTEM: 'system',
    AUTHENTICATION: 'authentication',
    EXTERNAL: 'external',
};
/**
 * Auditable Entity Types (extends EntityTypes)
 *
 * All entities that can be audited. Currently same as EntityTypes,
 * but can be extended with audit-specific entities if needed.
 */
export const AuditEntityTypes = {
    ...EntityTypes,
};
//# sourceMappingURL=entity-types.enum.js.map